document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-spotted-atc]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const handle = btn.dataset.handle;
  const singleVariant = btn.dataset.variantId;

  if (singleVariant) {
    addToCart(singleVariant, btn);
    return;
  }

  btn.disabled = true;
  fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`)
    .then(r => { if (!r.ok) throw new Error('No se pudo cargar el producto'); return r.json(); })
    .then(product => openPopup(product, btn))
    .catch(() => { window.location.href = `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}`; })
    .finally(() => { btn.disabled = false; });
});

function openPopup(product, triggerBtn) {
  document.querySelector('.spotted-popup-overlay')?.remove();

  const overlay = document.createElement('div');
  overlay.className = 'spotted-popup-overlay';
  overlay.innerHTML = `
    <div class="spotted-popup" role="dialog" aria-modal="true" aria-labelledby="spotted-popup-title">
      <button type="button" class="spotted-popup-close" aria-label="Cerrar selector de talles">✕</button>
      <h3 id="spotted-popup-title"></h3>
      <p>Seleccioná tu talle</p>
      <div class="spotted-popup-variants">
        ${product.variants.map(v => `
          <button class="spotted-variant-btn ${v.available ? '' : 'unavailable'}"
            data-variant-id="${v.id}"
            ${!v.available ? 'disabled' : ''}>
            ${v.title}
          </button>
        `).join('')}
      </div>
      <button class="spotted-popup-add" disabled>Añadir al carrito</button>
      <p class="spotted-popup-msg"></p>
    </div>
  `;

  overlay.querySelector('h3').textContent = product.title;
  overlay.querySelector('.spotted-popup-msg').setAttribute('role', 'status');
  overlay.querySelector('.spotted-popup-close').addEventListener('click', () => overlay.remove());
  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });

  let selectedVariant = null;
  overlay.querySelectorAll('.spotted-variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      overlay.querySelectorAll('.spotted-variant-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedVariant = btn.dataset.variantId;
      overlay.querySelector('.spotted-popup-add').disabled = false;
    });
  });

  overlay.querySelector('.spotted-popup-add').addEventListener('click', () => {
    if (!selectedVariant) return;
    addToCart(selectedVariant, overlay.querySelector('.spotted-popup-add'), overlay);
  });

  document.body.appendChild(overlay);
}

async function addToCart(variantId, btn, overlay) {
  if (btn.disabled) return;
  const originalContent = btn.innerHTML;
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const payload = { id: String(variantId), quantity: 1 };
  if (cart) {
    payload.sections = cart.getSectionsToRender().map(section => section.id);
    payload.sections_url = window.location.pathname;
    cart.setActiveElement(document.activeElement);
  }
  btn.textContent = 'Agregando...';
  btn.disabled = true;
  const msg = overlay?.querySelector('.spotted-popup-msg');
  if (msg) msg.textContent = '';
  let added = false;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'No se pudo agregar el producto. Intentá nuevamente.');
    added = true;
    if (overlay) overlay.remove();
    if (cart) {
      cart.classList.remove('is-empty');
      cart.renderContents(data);
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  } catch (err) {
    if (added) {
      window.location.href = window.Shopify.routes.root + 'cart';
    } else if (msg) {
      msg.textContent = err.message;
    }
  } finally {
    btn.innerHTML = originalContent;
    btn.disabled = false;
  }
}
